import { useState } from 'react';
import { useCreateHomeTabMutate } from '../../../../hooks/queries/home/useCreateHomeTabMutate';
import { HomeTabCreateErrorCode, HomeTabCreateRequest } from '../../../../types/home/tab';
import { CustomAxiosError } from '../../../../types/common/http';
import { HomeTabsCreateResponseBodyDto } from '../../../../types/api/home-tabs';

type UseCreateHomeTabReturnType = {
  isHomeTabCreateModalOpen: boolean;
  openHomeTabCreateModal: () => void;
  closeHomeTabCreateModal: () => void;
  createHomeTab: (tab: HomeTabCreateRequest) => void;
  isCreateHomeTabLoading: boolean;
};

interface UseCreateHomeTabProps {
  onSuccess?: (res: HomeTabsCreateResponseBodyDto) => void;
  onError?: (err: CustomAxiosError<HomeTabCreateErrorCode>) => void;
}

export const useCreateHomeTab = (props?: UseCreateHomeTabProps): UseCreateHomeTabReturnType => {
  const [isHomeTabCreateModalOpen, setIsHomeTabCreateModalOpen] = useState(false);

  const openHomeTabCreateModal = (): void => setIsHomeTabCreateModalOpen(true);

  const closeHomeTabCreateModal = (): void => setIsHomeTabCreateModalOpen(false);

  const { mutate, isLoading } = useCreateHomeTabMutate({
    onSuccess: (res) => {
      if (props?.onSuccess) props?.onSuccess(res);
    },
    onError: props?.onError,
    onSettled: closeHomeTabCreateModal,
  });

  return {
    isHomeTabCreateModalOpen,
    openHomeTabCreateModal,
    closeHomeTabCreateModal,
    createHomeTab: (tab: HomeTabCreateRequest): void => mutate(tab),
    isCreateHomeTabLoading: isLoading,
  };
};
